<template>
  <AppModal
    :heading="t('userLogoutAlert.title')"
    size="small"
    align-action="center"
    @modal-close="emits('exit')"
  >
    <template #actions>
      <scale-button variant="secondary" @click="emits('exit')">
        {{ t("userLogoutAlert.back") }}
      </scale-button>
      <scale-button @click="emits('logout')">
        {{ t("userLogoutAlert.logout") }}
      </scale-button>
    </template>
  </AppModal>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n"
import AppModal from "@/components/AppModal/AppModal.vue"

const { t } = useI18n()

const emits = defineEmits(["exit", "logout"])
</script>
